// extracted by mini-css-extract-plugin
module.exports = {"detailedItemListContainer":"RemoveStyleColorsWithoutQuantitiesList_detailedItemListContainer__ZdS5B","Item":"RemoveStyleColorsWithoutQuantitiesList_Item__1Ix64"};